import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { fadeInAnimation } from '../../animations/fade-in.animation';

@Component({
  selector: 'app-empty-result',
  templateUrl: './empty-result.component.html',
  styleUrls: ['./empty-result.component.scss'],
  animations: [fadeInAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyResultComponent {

  @HostBinding('@fadeInAnimation') get opened() {
    return true;
  }

  @Input('isPro') isPro = false;

  constructor() { }
}
